module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/32e097cfc94519493e9141415120a01a.gif";